import * as React from "react";
import { styled, css } from "styled-components";
import { mediaQueries } from "../../styles";
const StyledColumn = styled.div `
  --sg-row-width: ${({ elementWidth }) => elementWidth || "100%"};
  display: flex;
  flex-wrap: wrap;
  ${({ alignItems }) => (alignItems ? `align-items: ${alignItems};` : "")}
  ${({ justifyContent }) => justifyContent ? `justify-content: ${justifyContent};` : ""}

  max-width: 100%;
  padding-right: calc(var(--sg-gutter-x) / 2);
  padding-left: calc(var(--sg-gutter-x) / 2);
  margin-top: var(--sg-gutter-y);

  flex: ${({ elementWidth, large }) => large || elementWidth ? "0 0 auto" : "1 0 auto"};
  width: ${(props) => props.large
    ? css `calc(100% / 12 * ${props.large})`
    : css `var(--sg-row-width)`};

  ${mediaQueries.down("large") `
    flex: ${({ medium }) => medium ? "0 0 auto" : "1 0 auto"};
    width: ${({ medium }) => medium ? css `calc(100% / 12 * ${medium})` : css `var(--sg-row-width)`};
  `};

  ${mediaQueries.down("small") `
  flex: ${({ small }) => (small ? "0 0 auto" : "1 0 auto")};
    width: ${({ small }) => small ? css `calc(100% / 12 * ${small})` : css `var(--sg-row-width)`};
  `};
`;
export const Column = ({ small, medium, large, width, children, alignItems, justifyContent, }) => (React.createElement(StyledColumn, { small: small, medium: medium, large: large, elementWidth: width, alignItems: alignItems, justifyContent: justifyContent }, children));
export default Column;
//# sourceMappingURL=Column.js.map